import { render, staticRenderFns } from "./ModalCourseInfo.vue?vue&type=template&id=56fcbb43"
import script from "./ModalCourseInfo.vue?vue&type=script&lang=ts"
export * from "./ModalCourseInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports